import { DateTimeFormatter, Instant, nativeJs, ZonedDateTime, ZoneId, ZoneOffset } from 'js-joda';
import 'js-joda-timezone';

export class OdqDateTime {
  constructor(date: Date = new Date(), zoneId: string = 'Z') {
    if (date !== undefined) {
      this.zonedDateTime = this.getAsZonedDateTime(date, ZoneId.of(zoneId));
    } else {
      this.zonedDateTime = this.getAsZonedDateTime(new Date(), ZoneId.of(zoneId));
    }
  }
  private static quebecZoneId = 'America/Montreal';

  private zonedDateTime: ZonedDateTime;

  static now(): OdqDateTime {
    const zonedDateTime = ZonedDateTime.now(ZoneOffset.SYSTEM);
    const dateNow = OdqDateTime.zonedDateTimeToDate(zonedDateTime);
    return new OdqDateTime(dateNow);
  }

  static parse(value: string): OdqDateTime {
    const zonedDateTime = ZonedDateTime.parse(value, DateTimeFormatter.ISO_ZONED_DATE_TIME);
    const dateValue = OdqDateTime.zonedDateTimeToDate(zonedDateTime);
    return new OdqDateTime(dateValue);
  }

  static quebecNow(): OdqDateTime {
    return new OdqDateTime(undefined, this.quebecZoneId);
  }

  private static zonedDateTimeToDate(zonedDateTime: ZonedDateTime): Date {
    return new Date(
      zonedDateTime.year(),
      zonedDateTime.monthValue() - 1,
      zonedDateTime.dayOfMonth(),
      zonedDateTime.hour(),
      zonedDateTime.minute(),
      zonedDateTime.second(),
      0,
    );
  }

  toLocalDate(): Date {
    const instant = this.zonedDateTime.toInstant();
    const localZonedDate = ZonedDateTime.ofInstant(instant, ZoneId.SYSTEM);
    return OdqDateTime.zonedDateTimeToDate(localZonedDate);
  }

  toUtcDate(): Date {
    const instant = this.zonedDateTime.toInstant();
    const utcZonedDate = ZonedDateTime.ofInstant(instant, ZoneId.of('Z'));
    return OdqDateTime.zonedDateTimeToDate(utcZonedDate);
  }
  isBeforeQuebecDate(): boolean {
    const dateToCompareZonedDateTime = this.zonedDateTime;
    const quebecZonedDateTme = this.zonedDateTime.withZoneSameInstant(
      ZoneId.of(OdqDateTime.quebecZoneId),
    );
    return dateToCompareZonedDateTime.compareTo(quebecZonedDateTme) < 0;
  }

  isAfterQuebecDate(): boolean {
    const dateToCompareZonedDateTime = this.zonedDateTime;
    const quebecZonedDateTme = this.zonedDateTime.withZoneSameInstant(
      ZoneId.of(OdqDateTime.quebecZoneId),
    );
    return dateToCompareZonedDateTime.compareTo(quebecZonedDateTme) > 0;
  }

  toRfc3339(): string {
    const t = DateTimeFormatter.ofPattern('uuuu-MM-dd\'T\'HH:mm:ss.SSSSSSS[xxxx]');
    return this.zonedDateTime.format(t);
  }

  toDateInput(): string {
    const t = DateTimeFormatter.ofPattern('uuuu-MM-dd');
    return this.zonedDateTime.format(t);
  }

  private getAsZonedDateTime(date: Date, zoneId?: ZoneId): ZonedDateTime {
    const instant = Instant.from(nativeJs(date));
    let zonedDate;
    if (zoneId !== undefined) {
      zonedDate = ZonedDateTime.ofInstant(instant, zoneId);
    } else {
      zonedDate = ZonedDateTime.ofInstant(instant, ZoneId.systemDefault());
    }

    return zonedDate;
  }

  addDays(nbDays: number): OdqDateTime {
    const dateValue = OdqDateTime.zonedDateTimeToDate(this.zonedDateTime);
    dateValue.setDate(dateValue.getDate() + nbDays);
    return new OdqDateTime(dateValue);
  }

  addTime(time: number): any {
    const dateValue = OdqDateTime.zonedDateTimeToDate(this.zonedDateTime);
    const newDateWithoutTime = new Date(dateValue.getFullYear(), dateValue.getDay(), dateValue.getDate());
    newDateWithoutTime.setTime(time);
    return newDateWithoutTime;
  }
}
